const availableColours = ["#d73964", "#d23440", "#db643a", "#e88334", "#e2a71e", "#e25241", "#d0da59", "#4053ae", "#70b949", "#73564a", "#67ab5a", "#8f36aa", "#f6c244", "#52b9d0", "#4595ec", "#009688", "#5abeA7", "#4a97e4", "#2d68cd", "#9946c7", "#d9639e", "#6d6f74", "#939287", "#868ea3", "#2f4f4f", "#00ced1", "#ff00ff", "#6495ed", "#ff1493", "#ffdab9"];
const availableEmojis = ["📱", "📲", "☎️", "📞", "📟", "📠", "🔋", "🔌", "💻", "⌨️", "🖥️", "🖨️", "🖱️", "🖲️", "💽", "💾", "💿", "📀", "🎥", "📽️", "📺", "🎙️", "🎚️", "🎛️", "📡", "💡", "🔦", "📷", "📸", "📹", "📼", "🔍", "🔎", "🔬", "🔭", "📡", "💳", "🚀", "⏱️", "⏲️", "⏰", "🕰️", "⌛", "⏳", "📡", "🔋", "🔌", "💸", "💵", "💴", "💶", "💷", "💰", "💳", "🧾", "💹", "💱", "💲", "✉️", "📧", "📨", "📩", "📤", "📥", "📦", "📫", "📭", "📮", "🗳️", "✏️", "✒️", "🖋️", "🖊️", "🖌️", "🖍️", "📝", "📁", "📂", "🗂️", "📅", "📆", "🗒️", "🗓️", "📇", "📈", "📉", "📊", "📋", "📌", "📍", "📎", "🖇️", "📏", "📐", "✂️", "🗃️", "🗄️", "🗑️", "🔒", "🔓", "🔏", "🔐", "🔑", "🗝️", "🔨", "🪓", "⛏️", "⚒️", "🛠️", "🗡️", "⚔️", "🔫", "🏹", "🛡️", "🔧", "🔩", "⚙️", "🗜️", "⚖️", "🦺", "🔗", "⛓️", "🧰", "🧲", "⚗️", "🧪", "🧫", "🧬", "🔬", "🔭", "📡", "💉", "🩸", "💊", "🩹", "🩺", "🚪", "🛏️", "🛋️", "🪑", "🚽", "🚿", "🛁", "🪒", "🧴", "💌", "🏷️", "📪", "📬", "📯", "📜", "📃", "📄", "📑", "🗞️", "📰", "📓", "📔", "📒", "📕", "📗", "📘", "📙", "📚", "📖", "🔖", "🧷", "🗞️", "🔗", "🖇️", "🧾", "📌", "🎍", "💝", "🎎", "🎈", "🎅", "🎄", "🎁", "🔏", "🔐", "🔑", "💡", "🔦", "🔆", "🎓", "🎏", "🎆", "🎇", "🎐", "🎑", "🎃", "👻", "🔔", "🔕", "🎋", "🎉", "🎊", "💻", "🔮", "💿", "💾", "📷", "📹", "🎤", "🎧", "👞", "👡", "👠", "💄", "👢", "👕", "👕", "👔", "👚", "👗", "🎽", "👖", "👘", "👙", "🎀", "🎩", "👑", "👒", "👞", "🌂", "💼", "👜", "👝", "👛", "👓", "🎣", "☕", "🍵", "🍶", "🍼", "🍺", "🍻", "🍸", "🍹", "🍷", "🍴", "🍕", "🍔", "🍟", "🍗", "🍖", "🍝", "🍛", "🍤", "🍱", "🍣", "🍥", "🍙", "🍘", "🍚", "🍜", "🍲", "🍢", "🍡", "🥚", "🍞", "🍩", "🍮", "🍦", "🍨", "🍧", "🎂", "🍰", "🍪", "🍫", "🍬", "🍭", "🍯", "🍎", "🍏", "🍊", "🍋", "🍒", "🍇", "🍉", "🍓", "🍑", "🍈", "🍌", "🍐", "🍍", "🍠", "🍆", "🍅", "🌽", "🎨"];

// 🎒 :school_satchel:	🎓 :mortar_board:	🎏 :flags:
// 🎆 :fireworks:	🎇 :sparkler:	🎐 :wind_chime:
// 🎑 :rice_scene:	🎃 :jack_o_lantern:	👻 :ghost:
// 🎅 :santa:	🎄 :christmas_tree:	🎁 :gift:
// 🔔 :bell:	🔕 :no_bell:	🎋 :tanabata_tree:
// 🎉 :tada:	🎊 :confetti_ball:	🎈 :balloon:
// 🔮 :crystal_ball:	💿 :cd:	📀 :dvd:
// 💾 :floppy_disk:	📷 :camera:	📹 :video_camera:
// 🎥 :movie_camera:	💻 :computer:	📺 :tv:
// 📱 :iphone:	☎️ :phone:	☎️ :telephone:
// 📞 :telephone_receiver:	📟 :pager:	📠 :fax:
// 💽 :minidisc:	📼 :vhs:	🔉 :sound:
// 🔈 :speaker:	🔇 :mute:	📢 :loudspeaker:
// 📣 :mega:	⌛ :hourglass:	⏳ :hourglass_flowing_sand:
// ⏰ :alarm_clock:	⌚ :watch:	📻 :radio:
// 📡 :satellite:	➿ :loop:	🔍 :mag:
// 🔎 :mag_right:	🔓 :unlock:	🔒 :lock:
// 🔏 :lock_with_ink_pen:	🔐 :closed_lock_with_key:	🔑 :key:
// 💡 :bulb:	🔦 :flashlight:	🔆 :high_brightness:
// 🔅 :low_brightness:	🔌 :electric_plug:	🔋 :battery:
// 📲 :calling:	✉️ :email:	📫 :mailbox:
// 📮 :postbox:	🛀 :bath:	🛁 :bathtub:
// 🚿 :shower:	🚽 :toilet:	🔧 :wrench:
// 🔩 :nut_and_bolt:	🔨 :hammer:	💺 :seat:
// 💰 :moneybag:	💴 :yen:	💵 :dollar:
// 💷 :pound:	💶 :euro:	💳 :credit_card:
// 💸 :money_with_wings:	📧 :e-mail:	📥 :inbox_tray:
// 📤 :outbox_tray:	✉️ :envelope:	📨 :incoming_envelope:
// 📯 :postal_horn:	📪 :mailbox_closed:	📬 :mailbox_with_mail:
// 📭 :mailbox_with_no_mail:	🚪 :door:	🚬 :smoking:
// 💣 :bomb:	🔫 :gun:	🔪 :hocho:
// 💊 :pill:	💉 :syringe:	📄 :page_facing_up:
// 📃 :page_with_curl:	📑 :bookmark_tabs:	📊 :bar_chart:
// 📈 :chart_with_upwards_trend:	📉 :chart_with_downwards_trend:	📜 :scroll:
// 📋 :clipboard:	📆 :calendar:	📅 :date:
// 📇 :card_index:	📁 :file_folder:	📂 :open_file_folder:
// ✂️ :scissors:	📌 :pushpin:	📎 :paperclip:
// ✒️ :black_nib:	✏️ :pencil2:	📏 :straight_ruler:
// 📐 :triangular_ruler:	📕 :closed_book:	📗 :green_book:
// 📘 :blue_book:	📙 :orange_book:	📓 :notebook:
// 📔 :notebook_with_decorative_cover:	📒 :ledger:	📚 :books:
// 🔖 :bookmark:	📛 :name_badge:	🔬 :microscope:
// 🔭 :telescope:	📰 :newspaper:	🏈 :football:
// 🏀 :basketball:	⚽ :soccer:	⚾ :baseball:
// 🎾 :tennis:	🎱 :8ball:	🏉 :rugby_football:
// 🎳 :bowling:	⛳ :golf:	🚵 :mountain_bicyclist:
// 🚴 :bicyclist:	🏇 :horse_racing:	🏂 :snowboarder:
// 🏊 :swimmer:	🏄 :surfer:	🎿 :ski:
// ♠️ :spades:	♥️ :hearts:	♣️ :clubs:
// ♦️ :diamonds:	💎 :gem:	💍 :ring:
// 🏆 :trophy:	🎼 :musical_score:	🎹 :musical_keyboard:
// 🎻 :violin:	👾 :space_invader:	🎮 :video_game:
// 🃏 :black_joker:	🎴 :flower_playing_cards:	🎲 :game_die:
// 🎯 :dart:	🀄 :mahjong:	🎬 :clapper:
// 📝 :memo:	📝 :pencil:	📖 :book:
// 🎨 :art:	🎤 :microphone:	🎧 :headphones:
// 🎺 :trumpet:	🎷 :saxophone:	🎸 :guitar:
// 👞 :shoe:	👡 :sandal:	👠 :high_heel:
// 💄 :lipstick:	👢 :boot:	👕 :shirt:
// 👕 :tshirt:	👔 :necktie:	👚 :womans_clothes:
// 👗 :dress:	🎽 :running_shirt_with_sash:	👖 :jeans:
// 👘 :kimono:	👙 :bikini:	🎀 :ribbon:
// 🎩 :tophat:	👑 :crown:	👒 :womans_hat:
// 👞 :mans_shoe:	🌂 :closed_umbrella:	💼 :briefcase:
// 👜 :handbag:	👝 :pouch:	👛 :purse:
// 👓 :eyeglasses:	🎣 :fishing_pole_and_fish:	☕ :coffee:
// 🍵 :tea:	🍶 :sake:	🍼 :baby_bottle:
// 🍺 :beer:	🍻 :beers:	🍸 :cocktail:
// 🍹 :tropical_drink:	🍷 :wine_glass:	🍴 :fork_and_knife:
// 🍕 :pizza:	🍔 :hamburger:	🍟 :fries:
// 🍗 :poultry_leg:	🍖 :meat_on_bone:	🍝 :spaghetti:
// 🍛 :curry:	🍤 :fried_shrimp:	🍱 :bento:
// 🍣 :sushi:	🍥 :fish_cake:	🍙 :rice_ball:
// 🍘 :rice_cracker:	🍚 :rice:	🍜 :ramen:
// 🍲 :stew:	🍢 :oden:	🍡 :dango:
// 🥚 :egg:	🍞 :bread:	🍩 :doughnut:
// 🍮 :custard:	🍦 :icecream:	🍨 :ice_cream:
// 🍧 :shaved_ice:	🎂 :birthday:	🍰 :cake:
// 🍪 :cookie:	🍫 :chocolate_bar:	🍬 :candy:
// 🍭 :lollipop:	🍯 :honey_pot:	🍎 :apple:
// 🍏 :green_apple:	🍊 :tangerine:	🍋 :lemon:
// 🍒 :cherries:	🍇 :grapes:	🍉 :watermelon:
// 🍓 :strawberry:	🍑 :peach:	🍈 :melon:
// 🍌 :banana:	🍐 :pear:	🍍 :pineapple:
// 🍠 :sweet_potato:	🍆 :eggplant:	🍅 :tomato:
// 🌽 :corn:
// ]

export { availableEmojis as a, availableColours as b };
